import { render, staticRenderFns } from "./select-priority.vue?vue&type=template&id=58f4bc9e&"
import script from "./select-priority.vue?vue&type=script&lang=js&"
export * from "./select-priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports